import OfferMerchants from '../../OfferMerchants';

export default OfferMerchants;
